const ar = {
  placeholderText: "أدخل",
  closeContentText: "هل تريد إنهاء المحادثة الحالية؟",
  cancelText: "إلغاء",
  okText: "موافق",
  loadingAnswerQuestions:
    "جارٍ الإجابة على سؤالك السابق. يرجى الانتظار قبل الإرسال.",
  networkAnomalyText: "خطأ في الشبكة. يرجى المحاولة مرة أخرى لاحقًا.",
  errorText: "خطأ في الخادم",
  messageTooShort: "يجب إدخال حرفين على الأقل.",
  messageTooLong: "لا يمكن أن يتجاوز 200 حرف.",
  messageCannotBeEmpty: "لا يمكن أن يكون السؤال فارغًا",
  systemErrorText: "خطأ في النظام. يرجى المحاولة مرة أخرى لاحقًا.",
  fileSizeExceeded: "يجب ألا يتجاوز حجم الملف {maxSize} ميغابايت.",
  fileUploadSuccess: "تم تحميل الملف بنجاح",
  fileUploadFailed: "فشل تحميل الملف",
  emailErrorText: "تنسيق البريد الإلكتروني غير صالح.",
  emailEmptyText: "يرجى إدخال عنوان البريد الإلكتروني",
  uploadingText: "جارٍ التحميل...",
  abnormalDisconnectionText: "انقطع الاتصال. جارٍ إعادة الاتصال الآن...",
  reconnectToServerText: "تعذرت إعادة الاتصال بالخادم",
  evaluationText: "ملاحظاتك تساعدنا على التحسين!",
  emailLabel: "البريد الإلكتروني",
  emailPlaceholder: "أدخل عنوان بريدك الإلكتروني",
  productLabel: "المنتج",
  productPlaceholder: "اختر منتجًا",
  problemLabel: "وصف المشكلة",
  problemPlaceholder: "صف مشكلتك بالتفصيل",
  submitText: "إرسال",
  submitField: "عذرًا، فشل الإرسال. يرجى المحاولة مرة أخرى لاحقًا.",
  thankText:
    "شكرًا لتعاونك! سنتواصل معك في أقرب وقت ممكن! يرجى التحقق من بريدك الإلكتروني أو {link} للحصول على التحديثات!",
  clickHere: "انقر هنا",
  thankEvaluation: "شكرًا لملاحظاتك!",
  wsErrorText: "تعذر الاتصال بخدمة العملاء اليدوية",
  codeLabel: "رمز التحقق",
  codePlaceholder: "يرجى إدخال رمز التحقق",
  submittedSuccessfully: "تم الإرسال بنجاح",
  supportContact: "جهة اتصال الدعم",
  stillCancel: "لا يزال إلغاء",
  useDiscount: "استخدام الخصم",
  pauseDuration: "مدة الإيقاف",
  uploadAttachment: "تحميل مرفق",
};
export default ar;
